// import Record from  'common/js/UBaseRecord'
/**
 * 从手机获得照片
 * @param album true 代表相册获取 false 从相机获取 默认false
 * @param success 选取照片成功后回调，参数 照片地址
 * @param failure 选取照片失败后回调， 参数 错误原因
 */
import { commonParams } from 'common/config/config'
import { formatLimit } from 'common/utils/fileUtils'

export function getUser (success) {
  if (window.ULplugin && window.ULplugin.User) {
    window.ULplugin.User.getUser(function (user) {
      console.log(user)
      success && success(user)
    })
  }
}

const REFRESHACTIVELIST = 'UNotificationNameCourseActivitiesChange'

export function getPictureFromMobile (album = false, success, failure) {
  let sourceType = {}
  if (album) {
    sourceType.sourceType = 1
  }
  window.cameraExport.getPicture(function (result) {
    if (!/^file/.test(result)) {
      result = 'file://' + result
    }
    let fileName = result.split('/').pop().toString()
    success && success(result, fileName)
  }, function (err) {
    if (err.toLowerCase() !== 'no image selected') {
      failure && failure('相册权限未打开')
      return
    }
    failure && failure(err)
  }, sourceType)
}

export function selectFileFromAndroid (success) {
  // var fileType = '*.doc;*.mp3;*.mp4;*.rar;'
  var wordType = '*.doc;*.docx;*.xls;*.xlsx;*.pptx;*.ppt;*.pdf;*.txt;'
  var videoType = '*.mp4;*.avi;*.mov;*.flv;*.rmvb;*.mpg;'
  var audioType = '*.mp3;*.mov;'
  var picType = '.jpg;*.jpeg;*.png;*.gif;'
  var fileType = wordType + videoType + audioType + picType
  var fileSize = 200
  window.ULplugin.UFile.selectFile(fileType, fileSize)
  window.ULplugin.UFile.onSelectedFiles = function (fileCount, fileSize, filePath) {
    let fileModel = JSON.parse(filePath)[0]
    let Obj = {}
    if (fileModel.filepath && !/^file/.test(fileModel.filepath)) {
      Obj.filePath = 'file://' + fileModel.filepath
      Obj.fileType = formatLimit(fileModel.filepath)
      Obj.fileSize = fileModel.length
      Obj.fileName = fileModel.filename
    }
    success && success(Obj)
  }
}

// 等待状态
const ULRECORDREADY = 0

// 检查权限中
const ULRECORDCHECK = 1
// 录音中
const ULRECORDING = 2
// 录音结束
const ULRECORDEND = 3
// 检查权限拒绝
const ULRECORDDENY = 4

class Record {
  constructor () {
    // 录音的状态
    this.status = ULRECORDREADY
    // 文件路径
    this.filePath = ''
    // 当前声音时长
    this.currentDuration = 0
    // 录音最大时长
    this.durationLimit = 180
    // 定时器
    this._timer = {}

    this.onBeforeStartRecord = function () {
    }
    this.startRecord = function (success, failure, durationChange) {
      if (this.filePath) {
        this.filePath = ''
        this.status = ULRECORDREADY
      }
      // if (this.status !== ULRECORDREADY) {
      //   // 正在录音中，稍后重试
      //   failure && failure('正在录音请稍后重试')
      //   return
      // }
      // 状态切换为检查中
      this.status = ULRECORDCHECK
      this.onDurationChange = durationChange
      let _this = this
      window.ULplugin.URecorder.onStartRecord = function () {
        _this.onBeforeStartRecord && _this.onBeforeStartRecord()
        _this.status = ULRECORDING
        _this.currentDuration = 0
        _this._timer = setInterval(function () {
          if (_this.currentDuration >= _this.durationLimit) {
            window.ULplugin.URecorder.stopRecord()
            return
          }

          //  不录音时，或者时间超过限制，停止计时，停止录音
          if (_this.status === ULRECORDREADY || _this.status === ULRECORDEND || _this.currentDuration >= _this.durationLimit) {
            _this.stopRecord()
            console.log('我是清除定时器了')
            clearInterval(_this._timer)
            return
          }
          _this.currentDuration++
          _this.onDurationChange && _this.onDurationChange(_this.currentDuration)
        }, 1000)
      }
      window.ULplugin.URecorder.onRecordComplete = function (filePath) {
        _this.status = ULRECORDEND
        _this.filePath = filePath
        if (this._timer) {
          clearInterval(this._timer)
        }
        _this.onRecordCompleteSuccess && _this.onRecordCompleteSuccess(filePath, _this.currentDuration)
        _this.currentDuration = 0
      }
      window.ULplugin.URecorder.checkPermission(() => {
        //  权限允许
        success && success()
        window.ULplugin.URecorder.startRecord()
      }, (msg) => {
        _this.status = ULRECORDDENY
        failure && failure('请打开手机权限')
        //  权限拒绝
      })
    }

    this.stopRecord = function () {
      // this.status = ULRECORDREADY
      window.ULplugin.URecorder.stopRecord()
    }
    this.clearRecord = function () {
      this.status = ULRECORDREADY
      this.filePath = ''
      this.currentDuration = 0
      this.stopRecord()
    }
    // 录音完成的回调
    this.onRecordCompleteSuccess = function () {}

    this.onDurationChange = function () {}
  }
}

class Media {
  constructor () {
    // 图片查看
    this.imgPreview = function (imgpath) {
      window.ULplugin.UFile.imgPreview(imgpath)
    }
    // 打开文档
    this.openFileInOtherApp = function (path) {
      window.ULplugin.UFile.openFileInOtherApp(path)
    }
    // 打开视频
    this.openVideo = function (path) {
      window.ULplugin.UMedia.playVideo(path)
    }
  }
}

export function creatMedia () {
  return new Media()
}

/***
 *录音对象
 */
export function creatRecord () {
  return new Record()
}

/*
* 退出App
* */
export function exitApp () {
  window.ULplugin.UApp.finish()
}

// 打开外部连接带导航栏
export function openUrl (url) {
  window.ULplugin.UApp.openUrl(url)
}

// 更新活动列表通知
export function updateActiveList () {
  window.broadcaster.fireNativeEvent(REFRESHACTIVELIST, {}, function () {
  })
}

/*
* 给原生发送通知
* */
export function fireNativeEvent (name, callBack) {
  window.broadcaster.fireNativeEvent(name, {}, callBack)
}

/*
* 添加监听从原生发送的通知
* */
export function addNativeEvent (name, callback) {
  if (!window.broadcaster) {
    let timer = setInterval(() => {
      if (window.broadcaster) {
        window.broadcaster.addEventListener(name, callback)
        clearInterval(timer)
      }
    }, 200)
  } else {
    window.broadcaster.addEventListener(name, callback)
  }
}

class MobileUploder {
  constructor () {
    this.manger = {}
    let self = this
    this.uploadFile = function (filePath, progress, success, failure) {
      if (this.manger[filePath]) return
      let model = {}
      model.progress = progress
      model.success = success
      model.failure = failure
      this.manger[filePath] = model
      window.ULplugin.UUploader.onUploadProgress = function (filePath, progress) {
        let model = self.manger[filePath]
        if (model) {
          model.progress && model.progress(progress)
        }
      }
      window.ULplugin.UUploader.onUploadCancel = function (filePath) {
        let model = self.manger[filePath]
        if (model) {
          model.cancelSuccess && model.cancelSuccess()
        }
      }
      window.ULplugin.UUploader.onUploadSuccess = function (filePath, remotePath) {
        let model = self.manger[filePath]
        if (model) {
          remotePath = remotePath.replace(commonParams.QINIU_RESOURCE_URL, '')
          model.success && model.success(filePath, remotePath)
          delete self.manger[filePath]
        }
      }
      window.ULplugin.UUploader.onUploadFail = function (filePath) {
        let model = self.manger[filePath]
        if (model) {
          model.failure && model.failure()
        }
      }
      window.ULplugin.UUploader.upload(filePath)
    }
    this.cancelUpload = function (filePath, success) {
      if (!this.manger[filePath]) return
      let model = this.manger[filePath]
      model.cancelSuccess = success
    }
  }
}

export function createUploade () {
  return new MobileUploder()
}

class MobileDownloader {
  constructor () {
    this.downloadObj = {}
    // 检查远程文件的本地是否下载成功
    this.checkFileLocalPath = function (path, success, failure) {
      window.ULplugin.UFile.isExist(path, success, failure)
    }
    this.openFileInOtherApp = function (path) {
      window.ULplugin.UFile.openFileInOtherApp(path)
    }
    this.openVideo = function (path) {
      window.ULplugin.UMedia.playVideo(path)
    }
    // 检查网络状态
    this.checkNetworkStatus = function (success) {
      // 1、是wifi 2、是移动网 3、无网络
      window.ULplugin.UApp.networkState((status) => {
        success(status)
      })
    }
    // 开始下载
    this.download = function (path, progress, complete, failure) {
      this.addEventListener(path, progress, complete, failure)
      path = this.formateDownLoadPath(path, progress, complete, failure)
      console.log('我是开始下载了')
      console.log(path)
      window.ULplugin.UFile.download(path)
    }
    this.cancel = function (path) {
      window.ULplugin.UFile.cancelDownload(path)
    }
    // 格式化下载的路径
    this.formateDownLoadPath = function (path, progress, complete, failure) {
      let suffixName = path.split('/').pop()
      let filename = suffixName.split('.')[0]
      // let Obj = this.downloadObj[path]
      // if (!Obj) {
      //   this.downloadObj[path] = {
      //     path: path,
      //     name: suffixName,
      //     progressFns: [progress],
      //     completeFns: [complete],
      //     failureFns: [failure]
      //   }
      // } else {
      //   progress && Obj.progressFns.push(progress)
      //   complete && Obj.completeFns.push(complete)
      //   failure && Obj.failureFns.push(failure)
      // }
      return `${path}?name=${filename}`
    }
    // 添加事件监听，关闭页面，后台正在下载，注册监听方法，可以正确更新文件产状态
    this.addEventListener = function (path, progress, complete, failure) {
      let self = this
      let Obj = self.downloadObj[path]
      if (Obj) {
        Obj.progressFns.push(progress)
        Obj.completeFns.push(complete)
        Obj.failureFns.push(failure)
      } else {
        let suffixName = path.split('/').pop()
        this.downloadObj[path] = {
          path: path,
          name: suffixName,
          progressFns: [progress],
          completeFns: [complete],
          failureFns: [failure]
        }
      }
      window.ULplugin.UFile.onDownloadProgress = function (url, progress) {
        console.log('我是进度更新了')
        if (progress) {
          console.log(progress)
        }
        // console.log('我是进度更新了', url, progress)
        let Obj = self.downloadObj[url]
        if (Obj && Obj.progressFns && Obj.progressFns.length !== 0) {
          Obj.progressFns.forEach((item) => {
            if (progress) {
              item && item(progress)
            }
          })
        }
      }
      window.ULplugin.UFile.onDownloadError = function (url, errmsg) {
        console.log('我是下载错误了', url, errmsg)
        let Obj = self.downloadObj[url]
        if (Obj && Obj.failureFns && Obj.failureFns.length !== 0) {
          Obj.failureFns.forEach((item) => {
            item && item(errmsg)
          })
        }
      }
      window.ULplugin.UFile.onDownloadSuccess = function (url, filePath) {
        console.log('我是下载完成了', url, filePath)
        console.log(self.downloadObj)
        let Obj = self.downloadObj[url]
        if (Obj && Obj.completeFns && Obj.completeFns.length !== 0) {
          Obj.completeFns.forEach((item) => {
            item && item(filePath)
          })
        }
      }
    }
  }
}

export function creatDownloader () {
  return new MobileDownloader()
}



// WEBPACK FOOTER //
// ./src/common/js/mobilePlugin.js